import React from 'react';
import {
  HelpAnywhereCaretLeftSmallIcon,
  HelpAnywhereHomeOutlineIcon,
  HelpAnywhereHomeSolidIcon,
  HelpAnywhereRestartIcon,
  HelpAnywhereCloseIcon,
  HelpAnywhereDownloadIcon
} from '@apothecary/community-icons';
import PropTypes from 'prop-types';
import {Trans} from '@lingui/macro';

import './_Header.scss';
import debounce from 'lodash/debounce';

const Header = ({
  onClose,
  onReload,
  onBack,
  title,
  showClose,
  showReloadAndBack,
  showAvaConfirmModal = false,
  showSecRestart = false,
  onSecRestart,
  componentShowingInUH,
  showFeedbackWidgetFlow,
  openUHMThroughLink,
  contextualLinkOrigin,
  lastComponentShown,
  isInProduct,
  colorsToUpdate,
  updateIsEndChatThroughButton,
  uhmSubHeaderType,
  updateSaveChatTrigger,
  endChat,
  hideSubHeader,
  showConversationalContainer,
  hideHeader,
  expSalesBotAbTest,
  expEduAbTest
}) => {

  const endChatThroughButton = () => {
    updateIsEndChatThroughButton(true);
    // updateShowAgentAvailabilityFallback(false);
    endChat();
  };

  const debouncedSaveChat = () => {
    debounce(() => updateSaveChatTrigger(), 3000);
  };

  const restartChatButton = () => {
    return (
      <span
        className="header__restart-ava-action"
        data-testid="header-restart-ava"
        data-wat-val="restart-ava"
        onClick={onSecRestart}
      >
        <HelpAnywhereRestartIcon
          color="#666"
          width="18px"
          height="15px"
          className="header__restart-icon"
        />
        {'  '}
        <Trans>Restart chat</Trans>
      </span>
    );
  };

  const endChatButton = () => {
    return (
      <>
        <span
          onClick={endChatThroughButton}
          className="header__end-chat-action"
        >
          <HelpAnywhereCloseIcon
            width="17px"
            height="17px"
            className="header__end-chat-icon"
          />
          <span className="header__end-chat-text">
            <Trans>End chat</Trans>
          </span>
        </span>
      </>
    );
  };

  const saveTranscriptButton = () => {
    return (
      <span
        className="header__restart-ava-action"
        data-testid="header-restart-ava"
        data-wat-val="restart-ava"
        onClick={() => updateSaveChatTrigger()}
      >
        <HelpAnywhereDownloadIcon
          color="#666"
          width="18px"
          height="15px"
          className="header__restart-icon"
        />
        {'  '}
        <Trans>Save chat</Trans>
      </span>
    );
  };

  const avaSubHeader = () => {
    return (
      <span className="header__reload-end-container">
        {restartChatButton()}
        <>
          <div className="header__pipe--subheader-container">
            <span className="header__pipe--subheader" />
          </div>
          {endChatButton()}
        </>
      </span>
    );
  };

  const chatSubHeader = () => {
    return (
      <span className="header__reload-end-container">
        {saveTranscriptButton()}
        <>
          <div className="header__pipe--subheader-container">
            <span className="header__pipe--subheader" />
          </div>
          {endChatButton()}
        </>
      </span>
    );
  };

  const subHeader = (type) => {
    switch (type) {
      case 'AVA':
        return avaSubHeader();
      case 'chat':
        return chatSubHeader();
      default:
        return avaSubHeader();
        break;
    }
  };

  return (
    <div
      data-testid="header"
      className={
        'header' +
        (showReloadAndBack && !showAvaConfirmModal
          ? ' header--with-back'
          : '') +
        (showSecRestart && !showAvaConfirmModal ? ' header--with-ava' : '')
      }
    >
      {/* insert the value from web publishing team in the div below*/}
      <div
        style={{
          background:
            colorsToUpdate.headerColor !== '' ? colorsToUpdate.headerColor : '',
        }}
        className={`main-header${hideHeader ? '\u0020in-product' : ''}`}
      >
       {isInProduct || expSalesBotAbTest || expEduAbTest ? null : (
        <span
          className="header__reload"
          data-testid="header-reload"
          data-wat-val="start-over"
          onClick={() => onReload({userClick: true, fromLocation: 'uhm_home_click'})}
        >
          <HelpAnywhereHomeSolidIcon // Icon to show on hover - Hover state transition controlled by css
            className="icon-home--solid"
            color="#fff"
            data-wat-val="start-over"
            height="100%"
            width="100%"
          />
          <HelpAnywhereHomeOutlineIcon //Icon to show by default
            className="icon-home--outline"
            color="#fff"
            data-wat-val="start-over"
            height="100%"
            width="100%"
          />
        </span>
       )}
        <span className="header__title">
          {title !== '' ? title : <Trans>GET HELP</Trans>}
        </span>
        {/* <span className="header__pipe" /> */}
        {showClose ? (
          <span
            className="header__close"
            data-testid="header-close"
            data-wat-val="minimize"
            onClick={() => onClose({userClick: true})}
          >
            <div className="header__close-symbol" />
          </span>
        ) : null}
      </div>
      {!hideSubHeader &&
      ((showReloadAndBack && !showAvaConfirmModal && !showFeedbackWidgetFlow) || showConversationalContainer) ? (
        <div className={showConversationalContainer ? 'header--with-ava sub-header' : 'sub-header'}>
          {componentShowingInUH === 'AVA' || showConversationalContainer ? null : (
            <span
              className="header__back-action"
              data-testid="header-back"
              data-wat-val="back"
              onClick={onBack}
            >
              <HelpAnywhereCaretLeftSmallIcon
                color="#666"
                className="header__back-icon"
              />
              {'  '}
              <Trans>Back</Trans>
            </span>
          )}
          {(showSecRestart || showConversationalContainer) ? subHeader(uhmSubHeaderType) : null}
          <div className="sub-header__hrule" />
        </div>
      ) : null}
    </div>
  );
};

const noop = () => {};

// Set default props
Header.defaultProps = {
  title: '',
  showClose: true,
  showReloadAndBack: false,
  onClose: noop,
  onReload: noop,
  onBack: noop,
  uhmSubHeaderType: 'AVA',
  hideSubHeader: false,
  showConversationalContainer: false
};

// Set proptype rules
Header.propTypes = {
  showClose: PropTypes.bool,
  showReloadAndBack: PropTypes.bool,
  showAvaModal: PropTypes.bool,
  onClose: PropTypes.func,
  onReload: PropTypes.func,
  onBack: PropTypes.func,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  uhmSubHeaderType: PropTypes.string,
  updateSaveChatTrigger: PropTypes.func,
  hideSubHeader: PropTypes.bool,
  showConversationalContainer: PropTypes.bool
};

export default Header;
